import React from 'react';
import {ButtonList, ButtonItem, HeartButton, CommentButton, CountNum, AnimationBlock} from './style';
import heartIcon from 'images/heart-icon.png'
import heartIconActive from 'images/heart_icon.png'
import commentIcon from 'images/comment_icon.png'

import LottieLoader from 'components/containers/common/LottieLoader';

const FeedAndCommunityFooter = ({item, addLikeRequest, deleteLikeRequest, currentFeedNo, isLikeAnimation, lottieOptions, onClickComment}) => {
    return(
        <ButtonList>
            <ButtonItem>
                {item['liked_task'] ? 
                ( 
                isLikeAnimation && item['task_no'] === currentFeedNo ? 
                (<AnimationBlock>
                    <LottieLoader lottieOptions={lottieOptions} style={{ position: 'absolute',width: 'calc(100vw * (50.2 / 375))', height: 'calc(100vw * (45.8 / 375))', top: '-100%', left: '-100%', transform: 'translate(9.5%, 10.5%)'}}/> 
                </AnimationBlock>)
                :
                <HeartButton onClick={() => deleteLikeRequest(item)}>
                    <img src={heartIconActive}/>
                </HeartButton>) 
                : 
                (
                <HeartButton onClick={() => addLikeRequest(item)}>
                    <img src={heartIcon}/>
                </HeartButton> 
                )}
                <CountNum>{item['total_like']}</CountNum>
            </ButtonItem>
            <ButtonItem onClick={() => onClickComment(item)}>
                <CommentButton>
                    <img src={commentIcon}/>
                </CommentButton>
                <CountNum>{item['total_comment'] !== null ? item['total_comment'] : 0}</CountNum>
            </ButtonItem>
        </ButtonList>
    );
}

export default FeedAndCommunityFooter;